import type {MessageContentFunctionCall, ToolApprovalResponse} from "./types";
import {hasProposalChanges} from "./mutation-proposal";

export type ToolApproval = NonNullable<MessageContentFunctionCall["approval"]>;

/** An unreadable, expired, or empty preview can only be rejected. */
export const approvalCanBeApplied = (approval: ToolApproval, now: number) =>
   !approval.previewUnavailable &&
   (!approval.proposal || (Date.parse(approval.proposal.expiresAt) > now && hasProposalChanges(approval.proposal)));

/** A submission must decide every pending approval exactly once, with valid previews for approvals. */
export function canSubmitApprovalDecisions(pending: ToolApproval[], decisions: ToolApprovalResponse[], now: number): boolean {
   if (pending.length === 0) return false;

   const approvalsById = new Map(pending.map(approval => [approval.id, approval]));
   if (approvalsById.size !== pending.length) return false;

   const decisionIds = new Set(decisions.map(decision => decision.id));
   if (decisionIds.size !== decisions.length) return false;
   if (decisionIds.size !== approvalsById.size) return false;

   return decisions.every(decision => {
      const approval = approvalsById.get(decision.id);
      return !!approval && approval.approved === undefined && (!decision.approved || approvalCanBeApplied(approval, now));
   });
}
